// Require both the known message and its external source so app failures stay visible.
const knownExternalErrors = [
  {
    messageIncludes: ["Unexpected token 'R'", '"Restricted"', "is not valid JSON"],
    stackIncludes: "https://js.hsadspixel.net/pixels.js",
  },
  {
    messageIncludes: ["Error invoking postMessage: Java object is gone"],
    stackIncludes: "iabjs://navigation_performance_logger_android",
  },
];

export function isKnownExternalError(message: string, stack = ""): boolean {
  return knownExternalErrors.some(error => error.messageIncludes.every(part => message.includes(part)) && stack.includes(error.stackIncludes));
}

export function shouldFullySuppressError(errorMessage: string): boolean {
  const reallyNoisyErrorMessages = [
    // Noisy from various sources (e.g. media viewers, layout thrashing)
    "ResizeObserver", // "ResizeObserver loop completed with undelivered notifications."
  ];
  return reallyNoisyErrorMessages.some(message => errorMessage.includes(message));
}

export function shouldShowUserError(errorMessage: string): boolean {
  if (!errorMessage || errorMessage === "null") return false;

  // Exact match
  const noisyErrorExactMessages = ["Script error."];
  var isNoisyExact = noisyErrorExactMessages.some(message => errorMessage === message);
  if (isNoisyExact) return false;

  // Includes check
  const noisyErrorMessages = [
    "Expected mapDiv of type HTMLElement", // Google map issue when not visible (creator settings page)
    "/sapling",
    "api.amplitude.com",
    "widget.frill.co",
    "scrollLeft", // "Cannot read properties of null (reading 'scrollLeft')"
    "Cannot read properties of undefined (reading 'files')",
    "Failed to fetch icon", // This shouldn't happen, but if it does we don't want to flood them with toasts
    "evaluating 'e.contentWindow.postMessage'", // "null is not an object (evaluating 'e.contentWindow.postMessage')""
    "evaluating 'window.webkit.messageHandlers[e].postMessage'",
    "Cannot read properties of undefined (reading 'style')", // Noticed on a backend page
    "Cannot read properties of null (reading 'style')",
    "undefined is not an object (evaluating 'l[o].style')",
    "The play() request was interrupted",
    "The operation was aborted.",
    "Request aborted",
    "login_required",
    "undefined is not an object (evaluating 'media.duration')",
    "undefined is not an object (evaluating 'this.media.readyState'", // Covers a bunch of video errors
    "undefined is not an object (evaluating 'media.webkit", // Covers a bunch of video errors
    "properties of null (reading 'getBoundingClientRect')",
    "ReferenceError: og is not defined", // Posthog issue it seems, rarely happens but can be really spammy
    'Missing required param "creatorId"',
    'Missing required param "pageId"',
    'Missing required param "customerId"',
    // Sapling started failing
    "a2.includes is not a function",
    "Ue.includes is not a function",
    "Failed to fetch", // This is from the facebook pixel error below, but that url is just in the stack.  Ideally we'd check both.
    "Load failed", // This is the equivalent of ^, but from Safari
    "https://www.facebook.com/tr/",
    "Can't find variable: EmptyRanges",
  ];
  return !noisyErrorMessages.some(message => errorMessage.includes(message));
}
